import styled from 'styled-components';

export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: 100%;
`;

export const TableContainer = styled.div`
  flex: 1;
  max-height: 100%;
  overflow-y: auto;
`;

export const MainTable = styled.table`
  width: 100%;
  border-spacing: 0;
  flex: 1;
  background-color: var(--table-bg, #fff);
  border-radius: 0.5rem;
  border-collapse: collapse;
  font-family: inherit;

  &.cardTable {
    @media (max-width: 650px) {
      thead tr th:not(.collapseCell) {
        display: none;
      }

      tbody tr td:not(.collapseCell) {
        display: block;
        padding: 0.5rem 1rem;

        &:first-child {
          padding-top: 1rem;
        }

        &:last-child {
          padding-bottom: 1rem;
        }

        &::before {
          content: attr(data-cell) ": ";
          font-weight: 700;
          text-transform: capitalize;
        }
      }
    }
  }
`;

export const Thead = styled.thead`
  background-color: var(--table-thead-bg, #fff);
  border-bottom: 1px solid #ccc;
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const Row = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid #ccc;
  }
  &.collapseAbleRow {
    cursor: pointer;
  }
  &.errorRow {
    color: var(--table-error-color, #ff3632);
    td {
      color: #ce0c0c;
      text-align: center;
    }
  }
`;

export const Td = styled.td`
  font-size: var(--table-cell-fs, 0.875rem);
  color: var(--table-cell-color, #5f6d7e);
  padding: 0.75rem 1.5rem;
  vertical-align: middle;
  font-weight: var(--table-cell-fw, 500);
  word-wrap: break-word;
`;

export const Th = styled.th`
  color: var(--table-heading-color, #5f6d7e);
  padding: 1rem 1.25rem;
  font-size: var(--table-cell-fs, 0.875rem);
  font-weight: var(--table-heading-fw, 700);
  line-height: var(--table-cell-line-height, 1.125rem);
  letter-spacing: -0.00069rem;
  vertical-align: top;
  text-align: left;
`;

export const CollapseCell = styled.td`
  text-align: center;
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--table-pagination-bg, #fff);
  margin-top: 1rem;
  font-weight: 500;

`;

export const PaginationContainerMain = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: inherit;
  padding: 1rem 1.5rem;
  gap: 1rem;

  .btn {
    border: none;
    outline: none;
    background: var(--pagination-btn-bg, none);
    color: var(--pagination-btn-font-color, #000);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-family: inherit;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.25rem;
    letter-spacing: -0.00088rem;

    &:disabled {
      color: var(--pagination-disabled, #ccc);
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;

    li {
      list-style: none;
      line-height: 45px;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      cursor: pointer;
      user-select: none;
      transition: all 0.3s ease;

      &.numb {
        color: var(--pagination-numb-fc, #ccc);
        margin: 0 3px;
        line-height: 45px;
        border-radius: var(--pagination-numb-curve, 50%);
        background: var(--pagination-numb-bg, #fff);
        display: flex;
        width: 2.5rem;
        height: 2.5rem;
        padding: 0rem 1rem;
        justify-content: center;
        align-items: center;
        font-family: inherit;
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: -0.00088rem;
        transition: all 0.5s ease-in-out;

        &.first {
          margin: 0px 3px 0 -5px;
        }

        &.last {
          margin: 0px -5px 0 3px;
        }
      }

      &.dots {
        font-size: 22px;
        cursor: default;
        color: #ccc;
      }

      &.active,
      &:hover {
        color: var(--pagination-numb-active-fc, #000);
        background: var(--pagination-btn-active-bg, #a4a4a4);
      }
    }
  }
`;
